export default "__VITE_ASSET__DU7YcMp2__"